module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.player.num))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.player.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.player.ref_roster_line))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.player.M))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.player.F))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.player.Ag))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.player.Ar))]), _vm._v(" "), _c('td', _vm._l((_vm.player.skills), function(skill) {
    return _c('span', [_vm._v("\n         " + _vm._s(skill.name) + ",\n       ")])
  }), 0), _vm._v(" "), _c('td', [_vm._l((_vm.player.upgrades), function(up) {
    return (_vm.player.upgrades.length) ? _c('span', {
      class: _vm.getUpgradeStyle(up)
    }, [_vm._v("\n          " + _vm._s(_vm.getUpgradeName(up)) + ",\n       ")]) : _vm._e()
  }), _vm._v(" "), (_vm.player.downgrades) ? _c('span', {
    staticClass: "upgrade down"
  }, [_vm._v("\n          " + _vm._s(_vm.getDowngrades(_vm.player)) + ",\n       ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.player.customizations), function(cust) {
    return (_vm.player.customizations && _vm.player.customizations.length) ? _c('div', {
      staticClass: "upgrade stats"
    }, _vm._l((cust.skills), function(skill) {
      return (cust.skills) ? _c('span', [_vm._v(_vm._s(skill.name) + ", ")]) : _vm._e()
    }), 0) : _vm._e()
  })], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.player.total_xp))]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "additional_skills"
  }, [_vm._v(_vm._s(_vm.player.base_cost + _vm.player.evolution_cost) + "k")])]), _vm._v(" "), _c('td', [_vm._v("\n    " + _vm._s(_vm.season_break_info.played_seasons + _vm.season_break_info.custom.custom_played_seasons) + "\n  ")]), _vm._v(" "), (_vm.mode === 'read') ? [_c('td', [_vm._v("\n   " + _vm._s(_vm.season_break_info.is_leaving_roll) + "\n ")]), _vm._v(" "), _c('td', [(_vm.season_break_info.is_leaving === false) ? _c('div', [_vm._v("Non")]) : _c('div', [_vm._v("Oui")])]), _vm._v(" "), _c('td', [_vm._v("\n   " + _vm._s(_vm.season_break_info.niggling_cancelling) + "\n ")]), _vm._v(" "), _c('td', [(_vm.season_break_info.is_leaving === true) ? _c('span', {
    staticClass: "additional_skills"
  }, [_vm._v("\n     " + _vm._s(_vm.player.base_cost + _vm.player.evolution_cost + (_vm.season_break_info.played_seasons + _vm.season_break_info.custom.custom_played_seasons) * 20) + "k\n   ")]) : _c('span', {
    staticClass: "additional_skills"
  }, [_vm._v(_vm._s(_vm.player.base_cost + _vm.player.evolution_cost) + "k")])])] : _vm._e(), _vm._v(" "), (_vm.mode === 'write') ? [_c('td', {
    staticClass: "left-button"
  }, [_c('button', {
    staticClass: "row_button",
    on: {
      "click": function($event) {
        _vm.played_season_offset++
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "row_button",
    on: {
      "click": function($event) {
        _vm.played_season_offset--
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.season_break_info.played_seasons + _vm.played_season_offset))])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-710ffa4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/team/team-viewers/season-break-viewer/player-season-break-line.vue
// module id = 767
// module chunks = 0